import { render, staticRenderFns } from "./jumpForgetPas.vue?vue&type=template&id=6189c401&scoped=true"
import script from "./jumpForgetPas.vue?vue&type=script&lang=js"
export * from "./jumpForgetPas.vue?vue&type=script&lang=js"
import style0 from "./jumpForgetPas.vue?vue&type=style&index=0&id=6189c401&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189c401",
  null
  
)

export default component.exports